import './MyFavorites.scss';

import { Paginate } from '@icarros/torque-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EmptyState from '../../components/EmptyState';
import ListingItem from '../../components/ListingItem';
import { deleteFavorite, getMyFavorites } from '../../store/actions/myFavorites.actions';
import { scrollWindowToTop } from '../../utils/scroll';
import toastify from '../../utils/toastify';
import LoadingComponent from '../../components/Loading';

class MyFavorites extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadedInitialListings: false
    };

    scrollWindowToTop();

    this.getFavorites = this.getFavorites.bind(this);
    this.onSelectPage = this.onSelectPage.bind(this);
    this.canShowPaginate = this.canShowPaginate.bind(this);
    this.deleteFavorite = this.deleteFavorite.bind(this);
  }

  componentDidMount() {
    const { dispatchGetMyFavorites } = this.props;

    dispatchGetMyFavorites();
  }

  componentDidUpdate(prevProps) {
    this.checkLoadingUpdates(prevProps);
    this.checkDeletingUpdates(prevProps);
  }

  onSelectPage(page) {
    const { dispatchGetMyFavorites } = this.props;

    dispatchGetMyFavorites({ page });
  }

  setLoadedInitialListings(status) {
    this.setState({
      loadedInitialListings: status
    });
  }

  getFavorites() {
    const { content } = this.props;
    const { loadedInitialListings } = this.state;

    if (!loadedInitialListings) {
      return null;
    }

    if (!(content && content.length)) {
      return <EmptyState type="my-favorites" />;
    }

    return content.map((elem, index) => (
      <ListingItem
        parentId={`slc_qa_card${index}`}
        key={`favorites__item--${elem.id}`}
        className="listings__item"
        canDelete
        showListingAgent
        onClick={() => this.goToListing(elem)}
        onDelete={this.deleteFavorite}
        current={elem}
      />
    ));
  }

  checkDeletingUpdates(prevProps) {
    const { deleting, errorDeleting, number, numberOfElements, dispatchGetMyFavorites } =
      this.props;

    const wasDeleting = !deleting && prevProps.deleting;

    if (!wasDeleting) {
      return false;
    }

    if (errorDeleting) {
      return toastify.error('Erro ao deletar favorito. Tente novamente mais tarde');
    }

    const nextPage = (() => {
      if (numberOfElements > 1) {
        return number + 1;
      }
      return number || 1;
    })();

    dispatchGetMyFavorites({ page: nextPage });

    return toastify.success('Anúncio excluído dos seus favoritos');
  }

  checkLoadingUpdates(prevProps) {
    const { loading } = this.props;
    const { loadedInitialListings } = this.state;

    const wasLoading = !loading && prevProps.loading;

    if (!wasLoading) {
      return false;
    }

    if (!loadedInitialListings) {
      this.setLoadedInitialListings(true);
    }

    return true;
  }

  goToListing(elem) {
    const { link } = elem;

    window.open(link, '_blank');
  }

  deleteFavorite(id) {
    const { dispatchDeleteFavorite } = this.props;
    dispatchDeleteFavorite({ id });
  }

  canShowPaginate() {
    const { content } = this.props;
    const { loadedInitialListings } = this.state;

    return !!(loadedInitialListings && content && content.length);
  }

  render() {
    const { loading, totalPages, number, deleting } = this.props;

    return (
      <div className="my-favorites main-content">
        {(loading || deleting) && <LoadingComponent />}
        <div className="my-favorites__main">
          <span className="my-favorites__main-title">Meus Favoritos</span>
        </div>
        <div className="listings">{this.getFavorites()}</div>
        {this.canShowPaginate() && (
          <Paginate
            className="my-favorites__paginate"
            pages={totalPages}
            onSelect={this.onSelectPage}
            current={number + 1}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ myFavorites }) => ({
  content: myFavorites.content,
  totalPages: myFavorites.totalPages,
  totalElements: myFavorites.totalElements,
  last: myFavorites.last,
  first: myFavorites.first,
  size: myFavorites.size,
  number: myFavorites.number,
  sort: myFavorites.sort,
  numberOfElements: myFavorites.numberOfElements,
  loading: myFavorites.loading,
  error: myFavorites.error,
  deleting: myFavorites.deleting,
  errorDeleting: myFavorites.errorDeleting
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      dispatchGetMyFavorites: getMyFavorites,
      dispatchDeleteFavorite: deleteFavorite
    },
    dispatch
  );

MyFavorites.propTypes = {
  dispatchGetMyFavorites: PropTypes.func,
  dispatchDeleteFavorite: PropTypes.func,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number
    })
  ),
  deleting: PropTypes.bool,
  errorDeleting: PropTypes.bool,
  loading: PropTypes.bool,
  number: PropTypes.number,
  numberOfElements: PropTypes.number,
  totalPages: PropTypes.number
};

export default connect(mapStateToProps, mapDispatchToProps)(MyFavorites);
